
<script>
import { mapState } from "vuex"
import { isMobile } from 'mobile-device-detect'

export default {
  data () {
    return {
      isMobile: isMobile,
    }
  },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      buscaralertas: state => state.moduleAlerta.buscaralertas,
    }),
  },
  created() {

  },
  methods: {
    deletar(id){
      this.hideModal()
      this.$store.dispatch(
        "DELETARALERTA", {codigoUsuario: this.usuario.codUsuario, cidade: this.user.cidade, codigoAlerta: id}
      ).then(() => {
        this.showModal()
      })
    },
    showModal() {
      this.$store.dispatch(
        "BUSCARALERTAS", {codigoUsuario: this.usuario.codUsuario, cidade: this.user.cidade}
      ).then(() => {
        this.$bvModal.show('modal-consulta')
      })

    },
    hideModal() {
      this.$bvModal.hide('modal-consulta')
    },
    doisDigitos(num) {
      return num.toString().padStart(2, '0');
    },
    formatadoDateBR(date) {
      return [
        this.doisDigitos(date.getDate()),
        this.doisDigitos(date.getMonth() + 1),
        date.getFullYear(),
      ].join('/');
    }
  },
  watch: {
  }

}
</script>

<template>
  <div class="botao-inline">
    <b-button class="separador_botao" @click="showModal" variant='primary'>Consultar</b-button>
    <b-modal id="modal-consulta" hide-footer size="xl" scrollable v-if="!isMobile" > <!-- computador -->
      <template #modal-title>
        Alertas Cadastrados
      </template>
      <b-container fluid>
        <b-row class="mb-1">
          <b-col class='titulo' cols="2">Placa</b-col>
          <b-col class='titulo' cols="2">Cor</b-col>
          <b-col class='titulo' cols="2">Modelo</b-col>
          <b-col class='titulo' cols="2">Data Inicial</b-col>
          <b-col class='titulo' cols="2">Data Final</b-col>
          <b-col class='titulo' cols="2">Deletar</b-col>
        </b-row>

        <b-row class="mb-1" v-for="(alerta, i)  in buscaralertas" :key="i">
          <b-col cols="2">{{alerta.Placa}}</b-col>
          <b-col cols="2">{{alerta.Cor}}</b-col>
          <b-col cols="2">{{alerta.Modelo}}</b-col>
          <b-col cols="2">{{formatadoDateBR (new Date(alerta.DatInicio))}}</b-col>
          <b-col cols="2">{{formatadoDateBR (new Date(alerta.DatFinal))}}</b-col>
          <b-col cols="2">
            <b-btn pill variant="outline-danger" @click="deletar(alerta.CodOcorrencia)">
              <font-awesome-icon :icon="['fa', 'trash']" size="1x" class="icones_home"/>
            </b-btn>
          </b-col>
        </b-row>
      </b-container>

      <b-button class="mt-3" block @click="hideModal">Fechar</b-button>
    </b-modal>
    <b-modal id="modal-consulta" hide-footer size="xl" scrollable v-else> <!-- mobile -->
      <template #modal-title>
        Alertas Cadastrados
      </template>
      <b-container fluid>
        <b-row class="mb-1">
          <b-col class='titulo' cols=3>Placa</b-col>
          <b-col class='titulo' cols=7>Modelo</b-col>
          <b-col class='titulo' cols=1>Deletar</b-col>
        </b-row>

        <b-row class="mb-1" v-for="(alerta, i)  in buscaralertas" :key="i">
          <b-col cols=3>{{alerta.Placa}}</b-col>
          <b-col cols=7>{{alerta.Modelo}}</b-col>
          <b-col cols=1 > 
            <b-btn pill variant="outline-danger" @click="deletar(alerta.CodOcorrencia)">
              <font-awesome-icon :icon="['fa', 'trash']"/>
            </b-btn>
          </b-col>
        </b-row>
      </b-container>

      <b-button class="mt-3" block @click="hideModal">Fechar</b-button>
    </b-modal>
  </div>
</template>


<style scoped>
.botao-inline{
  display: inline-block;
}
.titulo{
  font-weight: 900;
}
</style>